// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { spacer8, spacer12, spacer16, spacer20, spacer24, spacer32, spacer80, screenSmMin, Type } from '@spotify-internal/encore-web';
import { Testimonial } from '../../SingleTestimonialModule/Testimonial';
import { ContentfulImage } from '../../../Contentful/ContentfulImage';
import { Box, ImageAspectBox1x1 } from '../../../ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Background = styled(Box).withConfig({
  displayName: "HeroTestimonial__Background",
  componentId: "sc-8k25h8-0"
})(["background-color:", ";color:", ";height:auto;&.tallest{height:100%;}"], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.textColor;
});
var HeroTestimonialStyled = styled.div.withConfig({
  displayName: "HeroTestimonial__HeroTestimonialStyled",
  componentId: "sc-8k25h8-1"
})(["display:flex;flex-direction:row-reverse;justify-content:", ";@media (max-width:", "){flex-direction:column;}"], function (props) {
  return props.centered ? 'center' : 'space-between';
}, screenSmMin);
var HeroTestimonialWrapper = styled.div.withConfig({
  displayName: "HeroTestimonial__HeroTestimonialWrapper",
  componentId: "sc-8k25h8-2"
})(["padding-top:", ";flex-direction:column;display:flex;justify-content:center;text-align:", ";@media (max-width:", "){padding-top:0px;}"], spacer20, function (props) {
  return props.centered ? 'center' : 'left';
}, screenSmMin);
var TestimonialWrapper = styled.div.withConfig({
  displayName: "HeroTestimonial__TestimonialWrapper",
  componentId: "sc-8k25h8-3"
})(["width:", ";@media (max-width:", "){width:100%;padding-top:", ";}"], function (props) {
  return props.centered ? '100%' : '65%';
}, screenSmMin, spacer12);
var ImageWrapper = styled(ImageAspectBox1x1).withConfig({
  displayName: "HeroTestimonial__ImageWrapper",
  componentId: "sc-8k25h8-4"
})(["width:30%;display:flex;align-items:center;height:fit-content;align-self:center;@media (max-width:", "){width:100%;margin-bottom:", ";}"], screenSmMin, spacer8);
var StyledSupertext = styled(Type).attrs({
  variant: Type.body1,
  weight: Type.bold
}).withConfig({
  displayName: "HeroTestimonial__StyledSupertext",
  componentId: "sc-8k25h8-5"
})(["padding-bottom:", ";text-transform:uppercase;@media (max-width:", "){padding-left:0;padding:", " 0px;width:100%;}"], spacer16, screenSmMin, spacer12);
var StyledSupertextNoPadding = styled(StyledSupertext).withConfig({
  displayName: "HeroTestimonial__StyledSupertextNoPadding",
  componentId: "sc-8k25h8-6"
})(["padding-bottom:0px;"]);
var TestimonialNoImageWrapper = styled.div.withConfig({
  displayName: "HeroTestimonial__TestimonialNoImageWrapper",
  componentId: "sc-8k25h8-7"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;"]);
var SupertextWrapper = styled.div.withConfig({
  displayName: "HeroTestimonial__SupertextWrapper",
  componentId: "sc-8k25h8-8"
})(["width:100%;display:flex;align-items:center;justify-content:center;@media (max-width:", "){text-align:center;}"], screenSmMin);
var StyledTestimonial = styled.div.withConfig({
  displayName: "HeroTestimonial__StyledTestimonial",
  componentId: "sc-8k25h8-9"
})(["display:flex;align-items:center;width:80%;@media (max-width:", "){width:100%;}"], screenSmMin);
var CenterText = styled.div.withConfig({
  displayName: "HeroTestimonial__CenterText",
  componentId: "sc-8k25h8-10"
})(["display:flex;flex-direction:column;justify-content:center;height:100%;width:80%;@media (max-width:", "){width:100%;}"], screenSmMin);
var TestimonialChar = styled(Type.h1).attrs({
  variant: Type.display2,
  weight: Type.bold
}).withConfig({
  displayName: "HeroTestimonial__TestimonialChar",
  componentId: "sc-8k25h8-11"
})(["font-size ", ";line-height:", ";padding-top:", ";padding-bottom:0px;@media (max-width:", "){padding-top:", ";}"], spacer80, spacer16, spacer32, screenSmMin, spacer16); // TODO: the font-size and line-heights below come directly from
// figma specs.  need to find a better way to do this

var TestimonialBody = styled(Type.p).attrs({
  variant: Type.heading2,
  weight: Type.book
}).withConfig({
  displayName: "HeroTestimonial__TestimonialBody",
  componentId: "sc-8k25h8-12"
})(["@media (max-width:", "){font-size:18px;line-height:", ";"], screenSmMin, spacer24);
var TestimonialSource = styled(Type.h1).attrs({
  variant: Type.heading3,
  weight: Type.bold
}).withConfig({
  displayName: "HeroTestimonial__TestimonialSource",
  componentId: "sc-8k25h8-13"
})(["padding-bottom:0px;@media (max-width:", "){visibility:hidden;}"], screenSmMin);
var SourceTitle = styled(Type.p).attrs({
  variant: Type.cta3
}).withConfig({
  displayName: "HeroTestimonial__SourceTitle",
  componentId: "sc-8k25h8-14"
})(["padding-top:", ";@media (max-width:", "){visibility:hidden;}"], spacer8, screenSmMin);
export var HeroTestimonial = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$supertext = _ref.supertext,
      supertext = _ref$supertext === void 0 ? '' : _ref$supertext,
      _ref$body = _ref.body,
      body = _ref$body === void 0 ? '' : _ref$body,
      image = _ref.image,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? '' : _ref$source,
      _ref$jobTitle = _ref.jobTitle,
      jobTitle = _ref$jobTitle === void 0 ? '' : _ref$jobTitle,
      backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor;
  var centered = image === undefined;
  return centered ? /*#__PURE__*/_jsx(Background, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    ref: ref,
    children: /*#__PURE__*/_jsxs(TestimonialNoImageWrapper, {
      children: [/*#__PURE__*/_jsx(SupertextWrapper, {
        children: /*#__PURE__*/_jsx(StyledSupertextNoPadding, {
          children: supertext
        })
      }), /*#__PURE__*/_jsx(StyledTestimonial, {
        children: /*#__PURE__*/_jsx(Testimonial, {
          quote: body,
          source: source,
          jobTitle: jobTitle,
          centered: centered,
          isHero: true
        })
      })]
    })
  }) : /*#__PURE__*/_jsx(Background, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    ref: ref,
    children: /*#__PURE__*/_jsx(HeroTestimonialWrapper, {
      centered: centered,
      children: /*#__PURE__*/_jsxs(HeroTestimonialStyled, {
        centered: centered,
        children: [image && /*#__PURE__*/_jsx(ImageWrapper, {
          children: /*#__PURE__*/_jsx(ContentfulImage, {
            asset: image
          })
        }), /*#__PURE__*/_jsx(TestimonialWrapper, {
          centered: centered,
          children: /*#__PURE__*/_jsxs(CenterText, {
            children: [/*#__PURE__*/_jsx(StyledSupertext, {
              children: supertext
            }), /*#__PURE__*/_jsx(TestimonialChar, {
              children: "\u201C"
            }), /*#__PURE__*/_jsx(TestimonialBody, {
              children: body
            }), /*#__PURE__*/_jsxs(TestimonialSource, {
              children: [" \u2014 ", source]
            }), /*#__PURE__*/_jsx(SourceTitle, {
              children: jobTitle
            })]
          })
        })]
      })
    })
  });
});